//#region imports
import { combineReducers } from 'redux';
import { AppState } from './rootReducerTypes';
import orderListReducer from './orderListActionsAndReducer';
import userInfoReducer from './userInfoActionsAndReducer';
import createOrderReducer from './createOrderActionsAndReducer';
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history';
import assetListReducer from './assetListActionsAndReducer';
import terminologiesReducer from './terminologiesActionsAndReducer';
import apiFeaturesReducer from './apiFeaturesActionsAndReducer';
import settingsReducer from './settingsActionsAndReducer';
import quoteListReducer from './quoteListActionsAndReducer';
import invoiceListReducer from './invoiceListActionsAndReducer';
import notificationListReducer from './notificationActionAndReducer';
import discrepanyListReducer from './discrepancyListActionsAndReducer';
import userReducer from './userReducer';

export const history = createBrowserHistory();

//#endregion
const appReducer = combineReducers<AppState>({
    orderList: orderListReducer,
    notificationList: notificationListReducer,
    invoiceList: invoiceListReducer,
    router: connectRouter(history),
    user: userReducer,
    userInfo: userInfoReducer,
    createOrderState: createOrderReducer,
    assetList: assetListReducer,
    terminologyState: terminologiesReducer,
    apiFeatureState: apiFeaturesReducer,
    settingState: settingsReducer,
    quoteList: quoteListReducer,
    discrepancyList: discrepanyListReducer
});

// meta-reducer whose only task is to clear the whole redux store upon logout
const rootReducer = (state: any, action: { type: string }): AppState  => {  
    return appReducer(state, action);
};

export default rootReducer;